import { Activity, BookOpen, Settings2 } from 'lucide-react';
import {
  filteredAdventureEntries,
  formatAdventureChange,
  formatWorldHour,
} from '../adventureLogModel.js';
import { locationMeta } from './worldMetadata.js';

function Entry({ entry, detailed }) {
  const location = entry.locationId ? locationMeta(entry.locationId) : null;
  const time = formatWorldHour(entry.worldHour);
  const meta = [`DAY ${entry.day}`, time || entry.period].filter(Boolean).join(' · ');
  return <article className={`v2-log-entry log-${entry.category} ${entry.important ? 'important' : ''}`}>
    <div className="v2-log-entry-meta"><span>{entry.category.toUpperCase()}</span><time>{meta}</time></div>
    <strong>{entry.title}</strong>
    <p>{entry.message}</p>
    {detailed && (location || entry.changes.length > 0) && <div className="v2-log-entry-details">
      {location && <span>{location.shortName || location.name}</span>}
      {entry.changes.map((change, index) => <b key={`${entry.id}-change-${index}`} className={change.delta < 0 ? 'negative' : change.delta > 0 ? 'positive' : ''}>{formatAdventureChange(change)}</b>)}
    </div>}
  </article>;
}

export function V2AdventurePanel({ gameState, uiSettings = {}, actions, desktopHeight = 0 }) {
  const enabled = uiSettings.adventure_log_enabled !== false;
  const filter = uiSettings.adventure_log_filter || 'all';
  const showRoutine = uiSettings.adventure_log_show_routine === true;
  const detailed = uiSettings.adventure_log_detail === 'detailed';
  const recentCount = Math.max(5, Math.min(20, Number(uiSettings.adventure_log_recent_count || 8)));
  const entries = filteredAdventureEntries(gameState, { filter, showRoutine }).slice(0, recentCount);
  const style = desktopHeight > 0 ? { '--v2-adventure-match-height': `${Math.ceil(desktopHeight)}px` } : undefined;

  if (!enabled) {
    return <aside className="v2-adventure-panel disabled" aria-label="Adventure Log disabled" style={style}>
      <header><div><span>ADVENTURE LOG</span><strong>Disabled</strong></div><Activity /></header>
      <div className="v2-adventure-disabled"><p>The run history is hidden by your Adventure Log settings.</p><button onClick={actions.openSettings}><Settings2 />Open settings</button></div>
    </aside>;
  }

  return <aside className="v2-adventure-panel fixed" aria-label="Adventure Log" style={style}>
    <header>
      <div><span>ADVENTURE LOG</span><strong>Run history</strong></div>
      <div className="v2-adventure-header-actions">{Number(actions.adventureDockUnread || 0) > 0 && <i className="v2-adventure-unread">{Math.min(99, actions.adventureDockUnread)}</i>}<button type="button" onClick={actions.openRunHistory} title="Open full Run History" aria-label="Open full Run History"><BookOpen /></button></div>
    </header>
    <div className="v2-adventure-scroll">
      {entries.length ? entries.map((entry) => <Entry key={entry.id} entry={entry} detailed={detailed} />) : <div className="v2-adventure-empty"><Activity /><strong>Nothing worth writing down yet.</strong><span>Suspicious.</span></div>}
    </div>
  </aside>;
}
